import React, { useEffect, useState } from "react";
import _ from "lodash";
import { FieldArray, useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import {
  amountByPercent,
  calculateDiscount,
  calculateTax,
  percentByAmount,
} from "../../../../../utils/utils";
import { AttachMoney, Percent } from "@mui/icons-material";
import { DialogActions, InputAdornment } from "@material-ui/core";
import NumberFormat from "react-number-format";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchTax from "../../../setup/finance/searchTax";
import Illustration from "../../../../../partials/content/Illustration";
import SearchGlAccount from "../../../setup/finance/searchGlAccount";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Card } from "react-bootstrap";
import { Typography } from "@material-ui/core";
import SearchCostComponent from "../../../setup/sales/cost-component/searchCostComponent";
function InvoiceItem({ property }) {
  const { setFieldValue, values } = useFormikContext();
  const [openSearchCostComp, setOpenSearchCostComp] = useState(false);
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchTax, setOpenSearchTax] = useState(false);
  //const [taxLevel, setTaxLevel] = useState("");
  //const [isHeader, setIsHeader] = useState(false);
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const [buttonGroupActive, setButtonGroupActive] = useState(0);
  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <FieldArray name={property}>
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values[property] && values[property].length > 0 ? (
                      <thead className="text-center">
                        <tr>
                          <th style={{ width: "25%" }}>Item Name</th>
                          <th style={{ width: "10%" }}>Quantity</th>
                          <th style={{ width: "10%" }}>Unit</th>
                          <th style={{ width: "20%" }}>Unit Price</th>
                          <th style={{ width: "15%" }}>Item Discount</th>
                          <th style={{ width: "20%" }}>Total Price</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody>
                      {values[property] && values[property].length > 0 ? (
                        values[property].map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <tr>
                                <td>
                                  <FormOutlinedNoMarginTextField
                                    value={`${item.itemCode} ${item.itemName}`}
                                    InputProps={{
                                      startAdornment:
                                        item.itemType > 0 ? (
                                          <InputAdornment position="start">
                                            <BootstrapTooltip
                                              title={item.itemTypeName}
                                            >
                                              <i
                                                className={
                                                  item.itemType === 1
                                                    ? "fas fa-boxes text-success"
                                                    : item.itemType === 2
                                                    ? "fas fa-tools text-primary"
                                                    : item.itemType === 3
                                                    ? "fas fa-building text-info"
                                                    : item.itemType === 4
                                                    ? "fas fa-boxes text-warning"
                                                    : item.itemType === 5
                                                    ? "fas fa-boxes text-danger"
                                                    : null
                                                }
                                              ></i>
                                            </BootstrapTooltip>
                                          </InputAdornment>
                                        ) : null,
                                      readOnly: true,
                                    }}
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    propName="qty"
                                    quantityField
                                    margin="none"
                                    readonly
                                    onBlur={() => {
                                      calculateDiscount(
                                        item.discountPercent,
                                        values,
                                        property,
                                        "percent",
                                        index,
                                        setFieldValue,
                                        "invoiceAddCost"
                                      );
                                      calculateItemTotalPrice(
                                        setFieldValue,
                                        item,
                                        index
                                      );
                                    }}
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    propName="uomName"
                                    margin="none"
                                    readonly
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    propName="unitPrice"
                                    margin="none"
                                    currencyField
                                    currencyCode={values.currencyCode}
                                    readonly
                                    onBlur={() => {
                                      calculateDiscount(
                                        item.discountPercent,
                                        values,
                                        property,
                                        "percent",
                                        index,
                                        setFieldValue,
                                        "invoiceAddCost"
                                      );
                                      calculateItemTotalPrice(
                                        setFieldValue,
                                        item,
                                        index
                                      );
                                    }}
                                  />
                                </td>
                                <td>
                                  {item.discountAmountType === 1 ? (
                                    <FormArrayTextField
                                      arrayPropName={property}
                                      index={index}
                                      propName="discountPercent"
                                      margin="none"
                                      readonly
                                      percentButton
                                      onPercentClick={() => {
                                        setFieldValue(
                                          `${property}[${index}].discountAmountType`,
                                          2
                                        );
                                      }}
                                    />
                                  ) : (
                                    <FormArrayTextField
                                      arrayPropName={property}
                                      index={index}
                                      propName="discountAmount"
                                      margin="none"
                                      currencyField
                                      currencyCode={values.currencyCode}
                                      readonly
                                      percentButton
                                      onPercentClick={() => {
                                        setFieldValue(
                                          `${property}[${index}].discountAmountType`,
                                          1
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    propName="totalPrice"
                                    margin="none"
                                    currencyField
                                    currencyCode={values.currencyCode}
                                    readonly
                                  />
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <tr>
                          <td className="text-center py-3" colSpan="6">
                            <Illustration
                              imageSource="INVIFO Payment.png"
                              guidance="You don't have any Invoice items yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            {values[property] && values[property].length > 0 ? (
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <Card>
                    <Card.Body className="py-0">
                      <Table borderless size="sm" responsive="xl">
                        <thead className="text-center">
                          {values.invoiceAddCost &&
                          values.invoiceAddCost.length > 0 ? (
                            <tr>
                              <th style={{ width: "40%" }}>Cost Name</th>
                              <th style={{ width: "25%" }}>Account</th>
                              <th style={{ width: "30%" }}>Cost Price</th>
                              <th>Actions</th>
                            </tr>
                          ) : null}
                        </thead>
                        <tbody>
                          {values.invoiceAddCost &&
                          values.invoiceAddCost.length > 0 ? (
                            values.invoiceAddCost.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {values.unbilledPercent === 100 ? (
                                    <React.Fragment>
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="invoiceAddCost"
                                          index={index}
                                          margin="none"
                                          propName="itemName"
                                          readonly
                                          searchButton={
                                            values.ID > 0 ? false : true
                                          }
                                          onSearchClick={() => {
                                            setItemIndex(index);
                                            setOpenSearchCostComp(true);
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="invoiceAddCost"
                                          index={index}
                                          margin="none"
                                          propName="accountName"
                                          readonly
                                          searchButton={
                                            values.ID > 0 ? false : true
                                          }
                                          onSearchClick={() => {
                                            setItemIndex(index);
                                            setOpenSearchGlAccount(true);
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="invoiceAddCost"
                                          index={index}
                                          margin="none"
                                          propName="costPrice"
                                          currencyField
                                          currencyCode={values.currencyCode}
                                          onBlur={() => {
                                            calculateTotalPrice(
                                              -1,
                                              false,
                                              -1,
                                              false
                                            );
                                          }}
                                        />
                                      </td>
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="invoiceAddCost"
                                          index={index}
                                          margin="none"
                                          propName="itemName"
                                          readonly
                                          searchButton={
                                            values.ID > 0 ? false : true
                                          }
                                          onSearchClick={() => {
                                            setItemIndex(index);
                                            setOpenSearchCostComp(true);
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="invoiceAddCost"
                                          index={index}
                                          margin="none"
                                          propName="accountName"
                                          readonly
                                          searchButton={
                                            values.ID > 0 ? false : true
                                          }
                                          onSearchClick={() => {
                                            setItemIndex(index);
                                            setOpenSearchGlAccount(true);
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="invoiceAddCost"
                                          index={index}
                                          propName="costPrice"
                                          currencyField
                                          margin="none"
                                          readonly
                                        />
                                      </td>
                                    </React.Fragment>
                                  )}
                                  <td
                                    style={{ whiteSpace: "nowrap" }}
                                    className="text-center"
                                  >
                                    {values.deliveryID > 0 ||
                                    item.soAddCostID === 0 ? (
                                      <BootstrapTooltip title="Delete Additional Cost">
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                          onClick={() => {
                                            let additionalCost = [];
                                            additionalCost = [
                                              ...values.invoiceAddCost,
                                            ];
                                            additionalCost = _.remove(
                                              additionalCost,
                                              function(value, indexArr) {
                                                return index !== indexArr;
                                              }
                                            );
                                            calculateTotalPrice(
                                              -1,
                                              false,
                                              index,
                                              !item.deleteInd
                                            );
                                            setFieldValue(
                                              `invoiceAddCost`,
                                              additionalCost
                                            );
                                          }}
                                        >
                                          <i className="fas fa-trash-alt"></i>
                                        </button>
                                      </BootstrapTooltip>
                                    ) : null}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan="4">
                                <Illustration
                                  guidance="No additional cost"
                                  guidanceLeftIcon="fas fa-info-circle kt-font-success"
                                ></Illustration>
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td className="text-center py-3" colSpan="4">
                              {values.unbilledPercent === 100 ? (
                                <button
                                  type="button"
                                  className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                  onClick={() => {
                                    const additionalCost = [
                                      ...values.invoiceAddCost,
                                    ];
                                    additionalCost.push({
                                      soAddCostID: 0,
                                      costComponentID: 0,
                                      itemName: "",
                                      costPrice: 0,
                                      revAccountID: 0,
                                      accountName: "",
                                      deleteInd: false,
                                    });
                                    setFieldValue(
                                      "invoiceAddCost",
                                      additionalCost
                                    );
                                  }}
                                >
                                  <i className="fas fa-plus-circle"></i>
                                  Additional Cost
                                </button>
                              ) : null}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography className="kt-font-bolder">
                                Additional Cost Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.addCostTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <Card className="mb-3">
                    <Card.Body className="pb-0">
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr className="border-bottom">
                            <td style={{ width: "50%" }}>
                              <Typography className="mb-3 kt-font-bolder">
                                Sub Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                component="div"
                                className="mb-3 kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.subTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          {values.deliveryCost > 0 ? (
                            <tr className="border-bottom">
                              <td>
                                <Typography className="my-3">
                                  Delivery Cost
                                </Typography>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                <Typography component="div" className="my-3">
                                  <NumberFormat
                                    value={values.deliveryCost}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div className="float-right">
                                        {values.currencyCode} {value}
                                      </div>
                                    )}
                                  />
                                </Typography>
                              </td>
                            </tr>
                          ) : null}
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.discountPercent}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div>
                                      Discount{" ("}
                                      {value}
                                      {"%)"}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.discountAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      - {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.taxPercent}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div>
                                      Tax{" ("}
                                      {value}
                                      {"%)"}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.taxAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Typography className="my-3">
                                Additional Cost
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.addCostTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                className="kt-font-bolder"
                              >
                                Grand Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.grandTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                  <Card>
                    <Card.Body className={values.ID === 0 ? "pb-0" : "py-0"}>
                      {values.deliveryID === 0 ? (
                        <React.Fragment>
                          {values.ID === 0 ? (
                            <Table borderless size="sm" responsive="xl">
                              <tbody>
                                <tr className="border-bottom">
                                  <td style={{ width: "50%" }}>
                                    <Typography
                                      component="div"
                                      className="mb-3"
                                    >
                                      <NumberFormat
                                        value={values.unbilledPercent}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        renderText={(value) => (
                                          <div>
                                            Unbilled Amount{" ("}
                                            {value}
                                            {"%)"}
                                          </div>
                                        )}
                                      />
                                    </Typography>
                                  </td>
                                  <td style={{ width: "0%" }}></td>
                                  <td style={{ width: "0%" }}></td>
                                  <td style={{ width: "50%" }}>
                                    <Typography
                                      component="div"
                                      className="mb-3"
                                    >
                                      <NumberFormat
                                        value={values.unbilledAmount}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        renderText={(value) => (
                                          <div className="float-right">
                                            {values.currencyCode} {value}
                                          </div>
                                        )}
                                      />
                                    </Typography>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          ) : null}
                          <Table borderless size="sm" responsive="xl">
                            <tbody>
                              <tr>
                                <td style={{ width: "25%" }}>
                                  <Typography className="mt-3 kt-font-bolder">
                                    Billed Amount
                                  </Typography>
                                </td>
                                <td style={{ width: "5%" }}>
                                  <div
                                    className="btn-group btn-group-sm my-2 float-right"
                                    role="group"
                                  >
                                    <BootstrapTooltip title="Input By Amount">
                                      <button
                                        type="button"
                                        className={`btn btn-${
                                          buttonGroupActive === 0
                                            ? "success"
                                            : "label-dark"
                                        } btn-sm btn-bold`}
                                        onClick={() => {
                                          setButtonGroupActive(0);
                                        }}
                                      >
                                        <AttachMoney />
                                      </button>
                                    </BootstrapTooltip>
                                    <BootstrapTooltip title="Input By Percentage">
                                      <button
                                        type="button"
                                        className={`btn btn-${
                                          buttonGroupActive === 1
                                            ? "success"
                                            : "label-dark"
                                        } btn-sm btn-bold`}
                                        onClick={() => {
                                          setButtonGroupActive(1);
                                        }}
                                      >
                                        <Percent />
                                      </button>
                                    </BootstrapTooltip>
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  {buttonGroupActive === 0 ? (
                                    <FormTextField
                                      label="Billing Amount"
                                      name="billAmount"
                                      currencyField
                                      currencyCode={values.currencyCode}
                                      onChangeValue={(value) => {
                                        calculateBillAmount(value, "amount");
                                      }}
                                      readonly={values.ID > 0 ? true : false}
                                    />
                                  ) : buttonGroupActive === 1 ? (
                                    <FormTextField
                                      label="Billing Percent"
                                      name="billPercent"
                                      percentageField
                                      onBlur={(value) => {
                                        calculateBillAmount(value, "percent");
                                      }}
                                      readonly={values.ID > 0 ? true : false}
                                    />
                                  ) : null}
                                </td>
                                <td style={{ width: "40%" }}>
                                  <Typography
                                    component="div"
                                    className="mt-3 kt-font-bolder"
                                  >
                                    <NumberFormat
                                      value={values.billAmount}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      renderText={(value) => (
                                        <div className="float-right">
                                          {values.currencyCode} {value}
                                        </div>
                                      )}
                                    />
                                  </Typography>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </React.Fragment>
                      ) : null}
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                className="kt-font-bolder"
                              >
                                Billing Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.billAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                </div>
              </div>
            ) : null}
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchCostComp}
        title="Search Cost Component"
        onCloseDialog={() => {
          setOpenSearchCostComp(false);
        }}
        maxWIdth="md"
      >
        <SearchCostComponent
          onSelectCostComponent={(cost) => {
            setFieldValue(
              `invoiceAddCost[${itemIndex}].costComponentID`,
              cost.ID
            );
            setFieldValue(
              `invoiceAddCost[${itemIndex}].itemName`,
              cost.costComponentName
            );
            setOpenSearchCostComp(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCostComp(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchTax}
        title="Search Tax"
        onCloseDialog={() => {
          setOpenSearchTax(false);
        }}
        maxWIdth="sm"
      >
        <SearchTax
          onSelectTax={(tax) => {
            calculateTax(
              tax.taxPercent,
              values,
              property,
              "percent",
              -1,
              setFieldValue,
              "invoiceAddCost"
            );
            setOpenSearchTax(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchTax(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchGlAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchGlAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID="6"
          onSelectGlAccount={(account) => {
            setFieldValue(
              `invoiceAddCost[${itemIndex}].revAccountID`,
              account.ID
            );
            setFieldValue(
              `invoiceAddCost[${itemIndex}].accountName`,
              account.accountName
            );
            setOpenSearchGlAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchGlAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function calculateTotalPrice(
    currIndex = -1,
    deleteInd = false,
    addCurrIndex = -1,
    addDeleteInd = false
  ) {
    const invoiceItem = [...values[property]];
    const additionalCost = [...values.invoiceAddCost];
    let subTotal = 0;
    let grandTotal = 0;
    let billAmount = 0;
    let addCostTotal = 0;
    const billPercent = parseFloat(values.billPercent);
    invoiceItem.forEach((item, indexQuote) => {
      if (!item.deleteInd && (!deleteInd || currIndex !== indexQuote)) {
        subTotal += parseFloat(item.totalPrice);
      } else if (!deleteInd && item.deleteInd && currIndex === indexQuote) {
        subTotal += parseFloat(item.totalPrice);
      }
    });
    additionalCost.forEach((item, index) => {
      if (!item.deleteInd && (!addDeleteInd || addCurrIndex !== index)) {
        addCostTotal += parseFloat(item.costPrice);
      } else if (!addDeleteInd && item.deleteInd && addCurrIndex === index) {
        addCostTotal += parseFloat(item.costPrice);
      }
    });
    const discountPercent = percentByAmount(values.discountAmount, subTotal);
    const taxAmount = amountByPercent(
      values.taxPercent,
      subTotal - values.discountAmount
    );
    grandTotal = subTotal - values.discountAmount + taxAmount;
    grandTotal += addCostTotal;
    if (billPercent > 0) {
      billAmount = amountByPercent(billPercent, grandTotal);
      setFieldValue(`billAmount`, billAmount);
      if (values.ID === 0) {
        setFieldValue("unbilledPercent", 100);
        setFieldValue("unbilledAmount", grandTotal);
      }
    }
    setFieldValue(`addCostTotal`, addCostTotal);
    setFieldValue(`subTotal`, subTotal);
    setFieldValue(`taxAmount`, taxAmount);
    setFieldValue(`discountPercent`, discountPercent);
    setFieldValue("grandTotal", grandTotal);
  }

  function calculateItemTotalPrice(setFieldValue, item, index) {
    const invoiceItem = [...values[property]];
    const additionalCost = [...values.invoiceAddCost];
    const totalPrice = item.unitPrice * parseFloat(item.qty);
    let billAmount = 0;
    const billPercent = parseFloat(values.billPercent);
    invoiceItem[index].totalPrice =
      totalPrice - item.discountAmount + item.taxAmount;
    invoiceItem[index].minimumPrice =
      item.oriMinimumPrice * parseFloat(item.qty);
    let subTotal = 0;
    let grandTotal = 0;
    let addCostTotal = 0;
    if (values) {
      invoiceItem.forEach((value) => {
        if (value.deleteInd === false) {
          if (value.totalPrice > 0) {
            subTotal += parseFloat(value.totalPrice);
          }
        }
      });
    }
    additionalCost.forEach((value) => {
      if (!value.deleteInd) {
        if (value.costPrice > 0) {
          addCostTotal += parseFloat(value.costPrice);
        }
      }
    });
    const discountPercent = percentByAmount(values.discountAmount, subTotal);
    const taxAmount = amountByPercent(
      values.taxPercent,
      subTotal - values.discountAmount
    );
    grandTotal = subTotal - values.discountAmount + taxAmount;
    grandTotal += addCostTotal;
    if (billPercent > 0) {
      billAmount = amountByPercent(billPercent, grandTotal);
      setFieldValue(`billAmount`, billAmount);
      if (values.ID === 0) {
        setFieldValue("unbilledPercent", 100);
        setFieldValue("unbilledAmount", grandTotal);
      }
    }
    setFieldValue(property, invoiceItem);
    setFieldValue(`addCostTotal`, addCostTotal);
    setFieldValue(`taxAmount`, taxAmount);
    setFieldValue(`discountPercent`, discountPercent);
    setFieldValue(`subTotal`, subTotal);
    setFieldValue(`grandTotal`, grandTotal);
  }

  function calculateBillAmount(value, type = "percent") {
    let billPercent = 0;
    let billAmount = 0;
    if (type === "percent") {
      billAmount = amountByPercent(
        parseFloat(value),
        parseFloat(values.grandTotal)
      );
      setFieldValue("billAmount", billAmount);
    } else if (type === "amount") {
      billPercent = percentByAmount(
        parseFloat(value),
        parseFloat(values.grandTotal)
      );
      setFieldValue("billPercent", billPercent);
    }
  }
}
export default InvoiceItem;
